import { memo, useEffect, useMemo, useState } from "react";
import { Chart } from "primereact/chart";

const Statistics = ({ data }) => {
  const [chartData, setChartData] = useState({});
  const [chartOptions, setChartOptions] = useState({});

  const arabicMonths = useMemo(
    () => [
      "يناير",
      "فبراير",
      "مارس",
      "أبريل",
      "مايو",
      "يونيو",
      "يوليو",
      "أغسطس",
      "سبتمبر",
      "أكتوبر",
      "نوفمبر",
      "ديسمبر",
    ],
    []
  );

  useEffect(() => {
    if (!data || data.length === 0) return;

    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue("--text-color");
    const textColorSecondary = documentStyle.getPropertyValue(
      "--text-color-secondary"
    );
    const surfaceBorder = documentStyle.getPropertyValue("--surface-border");

    const dataWithArabicMonths = data.map((item) => ({
      ...item,
      month_name_ar: arabicMonths[item.month - 1],
    }));

    const labels = dataWithArabicMonths.map((item) => item.month_name_ar);
    const totals = dataWithArabicMonths.map((item) =>
      typeof item.total_orders === "string"
        ? parseInt(item.total_orders)
        : item.total_orders
    );

    setChartData({
      labels,
      datasets: [
        {
          label: "عدد الطلبات",
          backgroundColor: "#183c6a",
          borderColor: "#183c6a",
          data: totals,
          borderRadius: 10,
          borderWidth: 1,
        },
      ],
    });

    setChartOptions({
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        legend: {
          labels: {
            color: textColor,
            font: {
              size: 14,
            },
          },
        },
      },
      scales: {
        x: {
          ticks: {
            color: textColorSecondary,
            font: {
              weight: 500,
              size: 12,
            },
          },
          grid: {
            display: false,
            drawBorder: false,
          },
        },
        y: {
          ticks: {
            color: textColorSecondary,
          },
          grid: {
            color: surfaceBorder,
            drawBorder: false,
          },
        },
      },
    });
  }, [data, arabicMonths]);

  return (
    <div className="card_info">
      <h3 className="title__">الإحصائيات</h3>
      <Chart type="bar" data={chartData} options={chartOptions} />
    </div>
  );
};

export default memo(Statistics);
